<template>
    <div v-if="visible" class="enter-change-dialog">
        <el-dialog v-model="visible" width="520" class="zh-dialog" center align-center show-close @close="onClose">
            <div class="enter-change-content">
                <div class="icon-wrap">
                    <span class="iconfont icon-Frame"></span>
                </div>
                <div v-if="!accountStore.isSubAccount" class="tip">您的企业认证已发生变更，请重新认证</div>
                <div v-else class="tip">当前企业认证信息已失效， 请等待重新认证生效后再登录。</div>
            </div>
            <template #footer>
                <div class="footer-wrap">
                    <el-button v-if="!accountStore.isSubAccount" @click="goToAuth">重新认证</el-button>
                    <el-button v-else @click="goLogin">确认</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script setup lang="ts">
import { useAccountStore } from "@/stores/account";
import { useRuntimeConfig } from "@/stores/runtimeConfig";
import { useUserStore } from "@/stores/user";
const accountStore = useAccountStore();
const userStore = useUserStore();
const visible = defineModel<boolean>("visible", { default: true });
const emits = defineEmits(["vanish"]);
// 去认证
const goToAuth = () => {
    const publicInfo = useRuntimeConfig().public as { publicPath: string };
    window.open(`${window.location.origin}${publicInfo.publicPath}/me/authentication`);
    emits("vanish");
};

const getConsoleAdminBaseUrl = () => {
    const consoleUIBaseUrl = `${window.location.origin}${useRuntimeConfig().public.publicPath}`;
    return consoleUIBaseUrl.endsWith("/console") ? consoleUIBaseUrl.slice(0, -8) : consoleUIBaseUrl;
};

// 退出登录
const goLogin = async () => {
    userStore.clear();
    window.location.href = `${getConsoleAdminBaseUrl()}/login`;
    ElMessage.success("已退出登录");
    emits("vanish");
};

const onClose = async () => {
    if (accountStore.isSubAccount) {
        await goLogin();
    }
};
</script>

<style scoped lang="scss">
.enter-change-dialog {
    :deep(.el-dialog) {
        border-radius: 12px;
        .enter-change-content {
            text-align: center;
            .icon-wrap {
                .iconfont {
                    font-size: 60px;
                    color: #ffc700;
                }
            }
            .tip {
                color: #333333;
                font-size: 20px;
                font-weight: 500;
                line-height: 20px;
                margin: 20px 0;
            }
        }
        .el-dialog__headerbtn {
            &:hover {
                .el-dialog__close {
                    color: #ffc700;
                }
            }
        }
        .el-dialog__header {
            border-bottom: none !important;
        }
    }
    .footer-wrap {
        padding-bottom: 26px;
        :deep(.el-button) {
            width: 150px;
            height: 40px;
            border-radius: 6px;
            background: #ffc700;
            border: none;
            color: #333333;
            font-size: 12px;
            font-weight: 500;
            line-height: 12px;
        }
    }
}
</style>
